module.exports = "//static.hsappstatic.net/ContentUtils/static-1.45892/img/choiceButtons/layout-minimal.svg"